<template>
	<div class="InventoryDisabled">
		<div class="card">
			<el-card
				v-if="type == 'inventory'"
				class="box-card"
				style="padding:50px;"
			>
				<h3>
					Optimize inventory using our predictive demand planning tool.
					<br />Use
					<span style="color: #e29d5a;">NymbleUp - Inventory Management</span>
					tool to manage orders, returns, take stock counts, manage delivery and
					record wastage.
				</h3>
				<p>
					To use this service, you need to upgrade your subscription. Please
					contact your administrator for more information.
				</p>
			</el-card>
			<el-card v-else-if="type == 'expiry'" class="box-card" style="padding:50px;">
				<h3>
					To use
					<span style="color: #e29d5a;"> NymbleUp - Expiry Management</span>
					tool, you need to upgrade your subscription.
					<br />
				</h3>
				<p>
					Please contact your administrator for more information.
				</p>
			</el-card>
			<el-card v-else-if="type == 'sales'" class="box-card" style="padding:50px;">
				<h3>
					For
					<span style="color: #e29d5a;"> NymbleUp - Sales,</span>
					 you need to upgrade your subscription.
					<br />
				</h3>
				<p>
					Please contact your administrator for more information.
				</p>
			</el-card>
			<el-card v-else-if="type == 'sales-forecast'" class="box-card" style="padding:50px;">
				<h3>
					Accurate Sales Forecast using machine learning and statistical tools to manage and plan your resources better
				</h3>
				<br>
				<h3>
					For
					<span style="color: #e29d5a;"> NymbleUp - Sales Forecast,</span>
					 you need to upgrade your subscription.
					<br />
				</h3>
				<p>
					Please contact your administrator for more information.
				</p>
			</el-card>
		</div>
	</div>
</template>

<script>
export default {
	name: "InventoryDashboard",
	props: {
		type: {
			type: String,
			default: () => ""
		}
	},
	data() {
		return {};
	},
	created() {
		console.log(this.type);
		if (this.type == "inventory") {
		}
	}
};
</script>

<style lang="scss">
.InventoryDisabled {
	.card {
		width: 70%;
		margin: 100px auto;
		h3 {
			line-height: 1.5;
		}
		p {
			line-height: 1.5;
			margin-top: 50px;
		}
	}
}
</style>
